import { NetworkSectionFilter, NetworkSectionSort } from '../core/domain/Network';
import { ExternalNetworkConfigurationPort } from '../core/networkState/ExternalNetworkConfigurationPort';

const NETWORK_PREFIX = 'network';
export class ExternalNetworkConfigurationProvider implements ExternalNetworkConfigurationPort {
    private readonly sortKey = `${NETWORK_PREFIX}-sort`;
    private readonly filterKey = `${NETWORK_PREFIX}-filter`;
    saveNetworkSectionsSort(sort: NetworkSectionSort): void {
        localStorage.setItem(this.sortKey, JSON.stringify(sort));
    }
    loadNetworkSectionsSort(): NetworkSectionSort {
        const storedSort = localStorage.getItem(this.sortKey);

        return storedSort ? JSON.parse(storedSort) : [];
    }
    saveNetworkSectionsFilter(filter: NetworkSectionFilter): void {
        localStorage.setItem(this.filterKey, JSON.stringify(filter));
    }
    loadNetworkSectionsFilter(): NetworkSectionFilter {
        const storedFilter = localStorage.getItem(this.filterKey);

        return storedFilter ? JSON.parse(storedFilter) : { items: [] };
    }
    saveNetworkSectionId(networkSectionId: string): void {
        localStorage.setItem(`${NETWORK_PREFIX}-network-section-id`, networkSectionId);
    }
    loadNetworkSectionId(): string | null {
        const networkSectionId = localStorage.getItem(`${NETWORK_PREFIX}-network-section-id`);

        return networkSectionId ?? null;
    }

    saveColumnVisibility(userId: string, model: Record<string, boolean>): void {
        localStorage.setItem(`${NETWORK_PREFIX}-columns-${userId}`, JSON.stringify(model));
    }

    loadColumnVisibility(userId: string): Record<string, boolean> {
        const stored = localStorage.getItem(`${NETWORK_PREFIX}-columns-${userId}`);

        return stored ? JSON.parse(stored) : {};
    }
}
